import { MRT_ColumnDef } from 'material-react-table'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { PolicyTableObject } from '../types'
import { Download } from '@carbon/icons-react'

export const useDownloadFilesTable = () => {
  const { t } = useTranslation()

  const columns = useMemo<MRT_ColumnDef<PolicyTableObject>[]>(
    () => [
      {
        accessorKey: 'name',
        header: t('common:name'),
      },
      {
        accessorKey: 'contractNumber',
        header: t('common:contractNumber'),
      },
      {
        accessorKey: 'datetime',
        header:  t('common:datetime'),
        enableSorting: false,
      },
      {
        accessorKey: 'fileName',
        header: t('common:fileName'),
        enableSorting: false,
      },
      {
        accessorKey: 'format',
        header: t('common:format'),
        size: 140,
        enableSorting: false,
      },
      {
        accessorKey: 'size',
        header: t('common:size'),
        size: 140,
        enableSorting: false,
      },
      {
        accessorKey: 'download',
        header: t('common:download'),
        Header: ({ column }) => (
          <Download width={16} height={16} />
        ), 
        enableSorting: false,
        size: 40,
        Cell: ({ renderedCellValue }) => (
          <a href={renderedCellValue?.toString()} target="_blank" rel="noopener noreferrer"><Download width={16} height={16} /></a>
        ),
      },
    ],
    [],
  )

  return { columns }
}
